export const locatorLinks = {
  locatorLink: () => ``,
}

export type LocatorLinks = typeof locatorLinks
